import { css } from "styled-components";

/**
 * Pressed-state feedback for touch. Spread into a styled button/card so a tap visibly responds while
 * the finger is down, by changing colour only; controls never change size. Each variant is `:active`
 * only, so hover styles are untouched, and each also turns off the browser's grey tap flash and the
 * double-tap-zoom delay.
 */
const tapBase = css`
	-webkit-tap-highlight-color: transparent;
	touch-action: manipulation;
`;

/** Filled pills and round icon buttons: the fill darkens. */
export const pressedDarken = css`
	${tapBase}

	&:active:not(:disabled):not([aria-disabled="true"]) {
		filter: brightness(0.88);
	}
`;

/** Rows, chips, cards and outlined controls: a soft brand-purple wash over the existing background. */
export const pressedTint = css`
	${tapBase}

	&:active:not(:disabled):not([aria-disabled="true"]) {
		background-image: linear-gradient(rgba(58, 12, 163, 0.1), rgba(58, 12, 163, 0.1));
	}
`;

/** Text-style links and buttons with no background: dim while pressed. */
export const pressedFade = css`
	${tapBase}

	&:active:not(:disabled):not([aria-disabled="true"]) {
		opacity: 0.55;
	}
`;
